module.exports = __webpack_public_path__ + "static/media/工程项目管理.cd82e57e.png";